import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import Controls from './../index';

export default function Popup(props) {
  const { title, children, openPopup, setOpenPopup, minHeight } = props;

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: '43%',
          minHeight,
        },
      }}
      open={openPopup}
      maxWidth="md"
    >
      <DialogTitle>
        <div style={{ display: 'flex' }}>
          <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <Controls.ActionButton
            color="primary"
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            <CloseIcon />
          </Controls.ActionButton>
        </div>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
